@if (loading) {
  <app-admin-state-panel
    mode="loading"
    titleKey="COMMON.LOADING"
    descriptionKey="ADMIN.USERS.DETAIL.LOADING"
  ></app-admin-state-panel>
} @else if (hasError || !user) {
  <app-admin-state-panel
    mode="error"
    titleKey="COMMON.ERROR"
    descriptionKey="ADMIN.USERS.DETAIL.ERROR"
    [showRetry]="true"
    (retry)="load()"
  ></app-admin-state-panel>
} @else {
  <app-admin-form-layout
    titleKey="ADMIN.USERS.DETAIL.ACCESS.FORM_TITLE"
    descriptionKey="ADMIN.USERS.DETAIL.ACCESS.FORM_DESCRIPTION"
  >
    <div class="vc-admin-user-access__status">
      <span class="vc-admin-user-access__status-label">
        {{ "ADMIN.USERS.ADMIN_STATUS_LABEL" | translate }}
      </span>
      <span class="vc-admin-user-access__status-value">
        {{ adminStatusLabelKey | translate }}
      </span>
    </div>

    @if (!isOwnUser && !isPrimaryAdmin) {
      <div class="mb-3 vc-admin-user-access__action">
        <button
          pButton
          type="button"
          class="p-button-sm"
          [severity]="user.isAdmin ? 'danger' : 'primary'"
          [label]="adminActionLabelKey | translate"
          (click)="confirmToggleAdmin()"
        ></button>
      </div>
    } @else if (isPrimaryAdmin) {
      <small class="text-secondary vc-admin-user-access__self-note">
        {{ "ADMIN.USERS.ADMIN_PRIMARY_LOCKED" | translate }}
      </small>
    } @else {
      <small class="text-secondary vc-admin-user-access__self-note">
        {{ "ADMIN.USERS.ADMIN_SELF_LOCKED" | translate }}
      </small>
    }

    <app-form-user-access [affectedUser]="user"></app-form-user-access>
  </app-admin-form-layout>
}
